import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { LetDirective } from '@ngrx/component';
import { Store } from '@ngrx/store';

import { PlanLevel } from '@ninety/platform/models/billing/plan-level';
import { selectLanguage } from '@ninety/platform/state';
import { BillingStateActions } from '@ninety/platform/state/app-global/billing/billing-state.actions';
import { TerraIconModule } from '@ninety/terra';
import { NinetyCMModule } from '@ninety/ui/core';
import { FilterBarActions } from '@ninety/web/pages/shared/layouts';

@Component({
  standalone: true,
  imports: [LetDirective, TerraIconModule, NinetyCMModule],
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: `
    <ninety-cm-tiered-page *ngrxLet="language$ as language">
      <div headline>Align Your Team With Clear {{ language.measurable.items }}</div>
      <div description>
        Unlock the {{ language.scorecard.item }} tool to track {{ language.measurable.items }} and targets. Ensure
        everyone is aligned on what success looks like, and drive strong performance across your team.
      </div>
      <button ninety-cm-button (click)="onExplorePlansClick()">
        <terra-icon icon="lightning" variant="fill" />
        Explore {{ pricingTierEnum.Essentials }} Plan
      </button>
    </ninety-cm-tiered-page>
  `,
})
export class ScorecardTieredPageComponent {
  private readonly store = inject(Store);

  language$ = this.store.select(selectLanguage);
  pricingTierEnum = PlanLevel;

  constructor() {
    this.store.dispatch(FilterBarActions.hide());
  }

  onExplorePlansClick(): void {
    this.store.dispatch(BillingStateActions.openPricingPlansModal());
  }
}
